<p-button
  (click)="handleOpen()"
  [ariaLabel]="'common.delete' | translate"
  [pTooltip]="'common.delete' | translate"
  icon="pi pi-trash"
  severity="secondary"
  styleClass="size-8 hover:bg-red-50! hover:text-red-600!"
  tooltipPosition="top"
  variant="text"
></p-button>

<p-dialog
  (onHide)="handleClose()"
  [(visible)]="openModal"
  [closable]="false"
  [modal]="true"
  [style]="{ width: '530px' }"
  maskStyleClass="backdrop-blur-sm"
>
  <ng-template pTemplate="header">
    <h6 class="text-2xl font-medium text-gray-900 dark:text-white mb-6">
      {{ 'connections.deleteModal.irreversible' | translate }}
    </h6>
  </ng-template>
  <p class="text-sm text-justify leading-relaxed space-y-6">
    {{ 'connections.deleteModal.confirmPrefix' | translate }}
    <strong class="text-primary-500">"{{ connection!.name }}"</strong>
    {{ 'connections.deleteModal.confirmSuffix' | translate }}
    <br />
    <span>
      {{ 'connections.deleteModal.warning' | translate }}
    </span>
  </p>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-4 pt-8">
      <p-button (click)="handleClose()" [label]="'common.cancel' | translate" variant="outlined" />
      <p-button (click)="handleDelete()" severity="danger">
        {{ 'connections.deleteModal.confirmDelete' | translate }}
      </p-button>
    </div>
  </ng-template>
</p-dialog>
